import React from 'react';
import { levelPills, volumes, volumeIncludes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:px-5 sm:py-20" data-id="element-213" data-mp="3ut2njcv9zxjp">
      <div className="mx-auto max-w-5xl text-center" data-id="element-214" data-mp="cp0zqecx549g">
        <p className="inline-block rounded-full border border-brand-500/40 bg-ink-700 px-4 py-2 text-[11px] font-extrabold uppercase tracking-[0.14em] text-brand-500 sm:text-sm" data-id="element-215" data-mp="cnpusb7qlqgr">
          🏆 SISTEMA DESPACHO TOTAL™
        </p>

        <h2 className="mt-6 text-2xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-216" data-mp="3c3mlum7utz1p">
          2 Tomos + 10 Bonos
          <span className="mt-2 block text-brand-500" data-id="element-217" data-mp="3pvki3wggw0gg">
            115+ páginas de ingeniería operativa. Todo resuelto.
          </span>
        </h2>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-2" data-id="element-218" data-mp="3l27xryitmfti">
          {levelPills.map(pill => <li key={pill} className="rounded-lg border border-brand-500/40 bg-ink-700 px-3 py-2 text-[11px] font-bold text-brand-400 sm:px-4 sm:text-sm" data-id="element-219" data-mp="2sfn7l1e309rj">
              {pill}
            </li>)}
        </ul>

        <ul className="mt-10 grid gap-4 text-left md:grid-cols-2" data-id="element-220" data-mp="2ed0nqk6zmlda">
          {volumes.map(volume => <li key={volume.title} className="rounded-2xl border border-white/10 bg-ink-800 p-6" data-id="element-221" data-mp="2j5tq51ezhhm7">
              <div className="flex items-center gap-3" data-id="element-222" data-mp="1qgwal625pyx5">
                <span aria-hidden="true" className="text-2xl" data-id="element-223" data-mp="1qi7h3dmzlkry">
                  {volume.icon}
                </span>
                <span className="rounded-full border border-brand-500/40 px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest text-brand-500" data-id="element-224" data-mp="1vhtt5jr2wuz6">
                  {volume.tag}
                </span>
              </div>
              <h3 className="mt-4 text-base font-extrabold text-white sm:text-lg" data-id="element-225" data-mp="3bu94dlqajvwh">
                {volume.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-226" data-mp="3fuj7mqmp887n">
                {volume.description}
              </p>
            </li>)}
        </ul>

        <div className="mt-12 rounded-3xl border border-brand-500/25 bg-ink-800 p-5 text-left sm:p-8" data-id="element-227" data-mp="1brzs1rfvvhad">
          <h3 className="text-center text-lg font-extrabold uppercase text-white sm:text-xl" data-id="element-228" data-mp="1ps0w1frg34u2">
            ✅ Cada tomo incluye:
          </h3>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-229" data-mp="1ksxo9nk2ykie">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-230" data-mp="x33e5dr5ba1u">
                <span aria-hidden="true" className="text-brand-500" data-id="element-231" data-mp="t21eivtbgvzc">
                  ✅
                </span>
                <span className="text-sm leading-relaxed text-gray-300" data-id="element-232" data-mp="16teujzs0nbpm">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}